import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../features/auth/authApi";
import lwsPortalImage from "../../assets/image/learningportal.svg";
import Error from "../../components/ui/Error";

export default function AdminLogin() {
	const loginError = useSelector((state) => state.auth?.loginError);

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");

	const [login, { data, error: responseError }] = useLoginMutation();

	const navigate = useNavigate();

	useEffect(() => {
		if (responseError?.data) {
			setError(responseError.data);
		}
		if (data?.accessToken && data?.user) {
			navigate("/admin");
		}
		if (loginError !== "") {
			setError(loginError);
		}
	}, [data, responseError, navigate, loginError]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setError("");
		const loginData = {
			data: {
				email,
				password,
			},
			isAdminLogin: true,
		};

		login(loginData);
	};

	return (
		<section className="py-6 bg-primary h-screen grid place-items-center">
			<div className="mx-auto max-w-md px-5 lg:px-0">
				<div>
					<img
						className="h-12 mx-auto"
						src={lwsPortalImage}
						alt="lws logo"
					/>
					<h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
						Sign in to Admin Account
					</h2>
				</div>
				<form onSubmit={handleSubmit} className="mt-8 space-y-6">
					<input type="hidden" name="remember" value="true" />
					<div className="rounded-md shadow-sm -space-y-px">
						<div>
							<label htmlFor="email-address" className="sr-only">
								Email address
							</label>
							<input
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								id="email-address"
								name="email"
								type="email"
								autoComplete="email"
								required
								className="login-input rounded-t-md"
								placeholder="Email address"
							/>
						</div>
						<div>
							<label htmlFor="password" className="sr-only">
								Password
							</label>
							<input
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								id="password"
								name="password"
								type="password"
								autoComplete="current-password"
								required
								className="login-input rounded-b-md"
								placeholder="Password"
							/>
						</div>
					</div>

					<div className="flex items-center justify-end">
						<div className="text-sm">
							<Link
								to="#"
								className="font-medium text-violet-600 hover:text-violet-500"
							>
								Forgot your password?
							</Link>
						</div>
					</div>

					<div>
						<button
							type="submit"
							className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
						>
							Sign in
						</button>
					</div>
					{error !== "" && <Error message={error} />}
				</form>
			</div>
		</section>
	);
}
